import React, {useEffect, useState} from "react";
import {Divider} from "@mui/material";
import i18n, {t} from "i18next";
import {DeliveryMethodsListProps, sortMethods} from "./calculator/delivery-methods-list";

export default function DeliveryMethodsListParcels({
                                                       deliveryMethods: providedDeliveryMethods,
                                                       weight: providedWeight,
                                                       weightUnit,
                                                       sort
                                                   }: DeliveryMethodsListProps) {

    const [deliveryMethods, setDeliveryMethods] = useState<any[] | null>(sortMethods(providedDeliveryMethods, sort))


    const renderTransportationMethod = (transportationMethod: string) => {
        if (transportationMethod == "Air")
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/air-mode.svg'} alt={''}/></div>
        else if (transportationMethod == "Ocean")
            return <div className={'icon-box'}><img
                src={'https://trtshopping.com/wp-content/uploads/2023/06/ocean-mode.svg'} alt={''}/></div>
        return <div className={'icon-box'}><img
            src={'https://trtshopping.com/wp-content/uploads/2023/06/air-mode.svg'} alt={''}/></div>
    }

    const renderCarrier = (carrier: any) => {
        if (carrier?.attachments?.length > 0 && carrier?.attachments[0]?.presignedPreviewUri)
            return <div className={'icon-box'}><img
                src={carrier?.attachments[0].presignedPreviewUri} alt={''}/></div>
        return <div className={'icon-box'}><img
            src={'https://trtshopping.com/wp-content/uploads/2023/07/carrier.svg'} width={30} alt={''}/></div>
    }

    useEffect(() => {
        if (providedDeliveryMethods)
            setDeliveryMethods(sortMethods(providedDeliveryMethods, sort))
    }, [providedDeliveryMethods, sort])

    return <div className={'delivery-methods'}>
        {deliveryMethods?.map((deliveryMethod, index) => {
                if (deliveryMethod?.totalAmount && deliveryMethod?.totalAmount > 0)
                    return <>
                        <div className={'delivery-method'}>
                            <div
                                className={'delivery-method-transportation-carrier'}
                            >
                                <div className={'icons'}>
                                    {renderTransportationMethod(deliveryMethod?.modeOfTransportation?.transportationMethod)}
                                    {renderCarrier(deliveryMethod?.carrier)}
                                </div>
                                <div className={'carrier-name'}>{/*deliveryMethod?.carrier?.name*/}</div>
                                <Divider orientation="vertical" variant="middle" flexItem/>
                            </div>
                            <div
                                className={'delivery-method-method-rate'}
                            >
                                <div>{deliveryMethod?.rateCustomValues?.["service_description_" + i18n.language ?? 'en']}
                                    {' - '}

                                    {t('deliveryMethods.from')}{' '}
                                    {deliveryMethod?.transitDaysMin}
                                    {' '}{t('deliveryMethods.upto')}{' '}
                                    {deliveryMethod?.transitDaysMax}
                                    {' '}
                                    {t('deliveryMethods.days')}
                                </div>
                                {
                                    deliveryMethod ? <div
                                            className={'delivery-method-rate'}>
                                            {deliveryMethod?.currencySymbol ?? "$"}{deliveryMethod?.totalAmount?.toFixed(2)}
                                        </div> :
                                        <div
                                            className={'delivery-method-rate'}>
                                            ${} {t('deliveryMethods.for')} {weightUnit ? t('weight.' + weightUnit?.toLowerCase()) : t('weight.kg')}
                                        </div>
                                }

                            </div>
                        </div>

                        {deliveryMethods?.length - 1 > index ?
                            <Divider flexItem/> : null}
                    </>
            }
        )}
        {deliveryMethods && deliveryMethods.length > 0 && (
            <div style={{
                marginTop: '16px',
                fontSize: '0.875rem',
                color: 'rgba(0, 0, 0, 0.6)',
                fontStyle: 'italic',
                textAlign: 'right'
            }}>
                {t('deliveryMethods.footnote')}
            </div>
        )}
    </div>
}